$(function () {
  if (!customElements.get('product-sticky-form-bottom')) {
    customElements.define(
      'product-sticky-form-bottom',
      class ProductStickyFormBottom extends HTMLElement {
        constructor() {
          super();
          this.lastScrollY = window.scrollY;
          this.ticking = false;
          this.timer = null;
          this.stickyDiv = null;
          this.$currentQuantity = 1;
          this.$productStickyFormBottom = null;
          this.shopMoneyFormat = window.shopMoneyFormat;
        }

        connectedCallback() {
          this.stickyDiv = $(this.querySelector('.sticky-div'));
          this.priceElement = this.querySelectorAll('.price');
          this.comparePriceElement = this.querySelectorAll('.compare_at_price');
          this.productStickyFormBottom = this.querySelector('.product-sticky-form-bottom');
          this.productStickyForm = document.querySelector('.product-sticky-form');
          this.$currentPrice = this.productStickyFormBottom.getAttribute('data-current-price');
          this.$comparePrice = this.productStickyFormBottom.getAttribute('data-compare-price');
          // 获取包含变体ID的section元素
          const stickyFormSection = this.querySelector('section.product-sticky-form-bottom');
          if (stickyFormSection) {
            // 获取URL中的variant参数
            const urlParams = new URLSearchParams(window.location.search);
            const urlVariantId = urlParams.get('variant');
            const defaultVariantId = stickyFormSection.getAttribute('data-variant-id');

            // 如果URL中有variant参数，使用它，否则使用默认的变体ID
            if (urlVariantId) {
              stickyFormSection.setAttribute('data-variant-id', urlVariantId);
            } else {
            }

            this.$productStickyFormBottom = stickyFormSection;
          } else {
            console.error('Sticky form section not found');
          }

          // 绑定所有事件
          this.bindEvents();
          this.handleAddToCartClick();
          this.handleBuyNowClick();

          // 初始化滚动监听
          this.handleScroll = () => {
            window.requestAnimationFrame(() => {
              const currentScrollY = window.scrollY;
              // 桌面端逻辑保持不变
              if (window.innerWidth > 768) {
                if (currentScrollY < this.lastScrollY) {
                  this.stickyDiv.removeClass('translate-y-full').addClass('translate-y-0');
                } else {
                  this.stickyDiv.removeClass('translate-y-0').addClass('translate-y-full');
                }
              }
              // 移动端专属逻辑
              else if (window.innerWidth <= 768) {
                const formRect = this.productStickyForm.getBoundingClientRect();
                const isOutOfForm = formRect.bottom <= 0; // 完全离开视口
              }

              this.lastScrollY = currentScrollY;
            });
          };

          // 添加滚动停止检测
          let scrollTimeout;
          window.addEventListener(
            'scroll',
            () => {
              if (this.productStickyForm && window.innerWidth <= 1200) {
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(() => {
                  const formRect = this.productStickyForm.getBoundingClientRect();
                  const isOutOfForm = formRect.bottom <= 0;
                }, 150);
              }
            },
            { passive: true }
          );
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.handleScroll);
          window.removeEventListener('quantityChange', this.handleQuantityChange);
          window.removeEventListener('updateEventShow', this.handleUpdateResult);
          if (this.timer) {
            clearTimeout(this.timer);
          }
        }

        bindEvents() {
          this.bindScrollEvent();
          this.bindPriceEvents();
          this.nowQuantityClick();
        }
        nowQuantityClick() {
          const $active_sku = document.querySelector('choose-products .active-sku');
          const addToCartBtn = this.querySelectorAll('.add-to-cart-btn');
          console.log('addToCartBtn', addToCartBtn);
          if ($active_sku) {
            const $active_sku_quantity = $active_sku.getAttribute('data-inventory_quantity');
            console.log('active_sku_quantity', $active_sku_quantity);
            if ($active_sku_quantity <= 0) {
              this.$currentQuantity = $active_sku_quantity;
              addToCartBtn.forEach((item) => {
                item.innerHTML = item.getAttribute('data-error-text');
                item.setAttribute('disabled', 'disabled');
              });
            } else {
              addToCartBtn.forEach((item) => {
                item.innerHTML = item.getAttribute('data-success-text');
                item.removeAttribute('disabled');
              });
            }
          }
        }
        bindPriceEvents() {
          // 处理数量变化事件
          this.handleQuantityChange = (event) => {
            this.$currentQuantity = event.detail;
            this.updatePrices();
            console.log('form-bottom执行');
          };
          window.addEventListener('quantityChange', this.handleQuantityChange);

          // 处理结果更新事件
          this.handleUpdateResult = (event) => {
            console.log('event', event);
            this.$currentPrice = event.detail.price;
            this.$comparePrice = event.detail.originalComparePrice;

            this.updatePrices();
          };
          window.addEventListener('updateEventShow', this.handleUpdateResult);
        }

        parsePriceString(priceString) {
          return priceString;
        }

        updatePrices() {
          let currentVarTotal = 0;
          let currentCompareVarTotal = 0;
          console.log('updatePrices_bottom执行');
          if (document.querySelectorAll('.products-select-menu')) {
            document.querySelectorAll('.products-select-menu').forEach((element) => {
              const currentPrice = parseFloat(element.getAttribute('data-current-price') || 0);
              const comparePrice = parseFloat(element.getAttribute('data-compare-price') || 0);
              const quantity = parseFloat(element.getAttribute('data-quantity') || 0);

              // 计算并累加总金额
              currentVarTotal += currentPrice * quantity;
              currentCompareVarTotal += comparePrice * quantity;
            });
          }
          console.log(' currentVarTotal_bottom', currentVarTotal);
          console.log(' currentCompareVarTotal_bottom', currentCompareVarTotal);
          if (this.priceElement) {
            const originalPrice = this.parsePriceString(this.$currentPrice);
            const newPrice = originalPrice * this.$currentQuantity + currentVarTotal;
            console.log('newPrice222999', newPrice);
            console.log('originalPrice999', originalPrice);
            console.log('currentVarTotal', currentVarTotal);
            console.log('this.$currentQuantity', this.$currentQuantity);
            this.priceElement.forEach((element) => {
              element.innerHTML = window.Shopify.formatMoney(newPrice, this.shopMoneyFormat);
            });
          }

          if (this.comparePriceElement) {
            const originalComparePrice = this.parsePriceString(this.$comparePrice);
            console.log('originalComparePrice222', originalComparePrice);
            console.log('currentCompareVarTotal', currentCompareVarTotal);
            console.log('this.$currentQuantity', this.$currentQuantity);
            const newComparePrice = originalComparePrice * this.$currentQuantity + currentCompareVarTotal;
            console.log('newComparePrice222222', newComparePrice);
            this.comparePriceElement.forEach((element) => {
              element.innerHTML = window.Shopify.formatMoney(newComparePrice, this.shopMoneyFormat);
            });
          }
        }

        bindScrollEvent() {
          this.handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (!this.ticking) {
              window.requestAnimationFrame(() => {
                this.lastScrollY = currentScrollY;
                this.ticking = false;
              });

              this.ticking = true;
            }
          };

          window.addEventListener('scroll', this.handleScroll, { passive: true });
        }
        handleBuyNowClick() {
          // 确保有section元素
          if (!this.$productStickyFormBottom) {
            console.error('Sticky form section not found');
            return;
          }

          const variantId = this.$productStickyFormBottom.getAttribute('data-variant-id');
          const buyNowBtn = this.querySelector('.buy-now-btn');

          if (buyNowBtn) {
            buyNowBtn.addEventListener('click', async (event) => {
              event.preventDefault();
              const quantity = this.$currentQuantity;

              // 获取选中的产品数据
              const selectedProducts = window.selectedProducts || [];

              try {
                // 使用 Shopify Ajax API 添加商品到购物车
                const response = await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    items: [
                      // 添加当前产品
                      {
                        id: parseInt(variantId),
                        quantity: parseInt(quantity),
                      },
                      // 添加其他选中的产品
                      ...selectedProducts.map((product) => ({
                        id: product.variantId,
                        quantity: parseInt(product.quantity),
                      })),
                    ],
                  }),
                });
                if (!response.ok) {
                  throw new Error('Failed to add items to cart');
                }
                if (window.gtag) {
                  gtag('event', 'conversion', { send_to: 'AW-11059876179/3GvVCJvMxIsYENOi4Zkp' });
                }
                // 添加成功后直接跳转到结账页面
                window.location.href = '/checkout';
              } catch (error) {}
            });
          }
        }
        handleAddToCartClick() {
          if (!this.$productStickyFormBottom) {
            console.error('Sticky form section not found');
            return;
          }

          const addToCartBtn = this.querySelectorAll('.add-to-cart-btn');
          console.log('addToCartBtn', addToCartBtn);
          if (addToCartBtn) {
            addToCartBtn.forEach((item) => {
              item.addEventListener('click', async (event) => {
                const variantId = this.$productStickyFormBottom.getAttribute('data-variant-id');

                event.preventDefault();
                const quantity = this.$currentQuantity;

                // 获取选中的产品数据
                const selectedProducts = window.selectedProducts || [];

                try {
                  // 使用 Shopify Ajax API 添加商品到购物车
                  const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      items: [
                        // 添加当前产品
                        {
                          id: parseInt(variantId),
                          quantity: parseInt(quantity),
                        },
                        // 添加其他选中的产品
                        ...selectedProducts.map((product) => ({
                          id: product.variantId,
                          quantity: parseInt(product.quantity),
                        })),
                      ],
                      sections: 'cart-drawer,cart-icon-bubble',
                    }),
                  });
                  if (window.gtag) {
                    gtag('event', 'conversion', { send_to: 'AW-11059876179/OfmnCMjGxIsYENOi4Zkp' });
                  }
                  if (response.ok) {
                    const cartContent = await response.json();
                    await updateCartComponents(cartContent);

                    // 打开购物车抽屉
                    const cartDrawer = document.querySelector('cart-drawer');
                    if (cartDrawer) {
                      cartDrawer.open();
                    }
                  } else {
                    const errorData = await response.json();
                    console.error('Add Cart error:', errorData);
                    window.GlobalPrompt.show(errorData.description || 'Failed to Add to Cart', 'error', 'drawer');
                  }
                } catch (error) {
                  console.error('Error:', error);
                  window.GlobalPrompt.show('Failed to Add to Cart', 'error', 'drawer');
                }
              });
            });
          }
        }
      }
    );
  }
});
